'use client';
import { getDefaultZIndex } from '@s7/styles';

const IDENT = 'TabNavigationWidget';
const defaultProps = {
    zIndex: getDefaultZIndex('modal')
};

export { IDENT, defaultProps };
//# sourceMappingURL=TabNavigationWidget.contract.js.map
